export const setAnalyticsData = () => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const pageData = {
    pageInfo: {
      pageLoadEvent: 'gift cards check balance success',
      pageName: 'gift card>check balance and reload',
      pageType: 'gift cards'
    },
    category: {
      primaryCategory: 'gift cards',
      subCategory1: 'gift cards>check balance and reload',
      subCategory2: 'gift cards>check balance and reload'
    }
  };
  LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('giftcards.reload-balance', pageData);
};

export const setScanningAnalytics = (isSuccess) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const eventData = {
    category: {
      primaryCategory: 'button submission'
    },
    eventInfo: {
      eventName: 'my account settings'
    },
    myAccount: {
      settings: isSuccess
        ? 'gift card: check balance and reload: scan gift card barcode success'
        : 'gift card: check balance and reload: scan gift card barcode button click'
    }
  };
  try {
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(eventData);
    const _ddo = window.digitalData.init();
    window._T = window._T || {};

    if (typeof window._T.pageData === 'undefined') {
      window._T.pageData = [];
    }

    window._T.pageData.push(_ddo);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};

export const setATCAnalytics = (cartID, price) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }

  try {
    if (!window?.digitalData?.cart) {
      window.digitalData.cart = {};
    }
    window.digitalData.cart = {
      cartID,
      price: {
        cartTotal: price
      },
      item: [
        {
          productInfo: { sku: '999999999' },
          price: {
            basePrice: '0.00',
            giftCardPrice: '00.00',
            giftCardReloadPrice: price
          },
          fulfillment: { method: 'sth' }
        }
      ]
    };
    window.digitalData.event = window.digitalData.event || [];

    const eventData = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'cart add location'
      },
      eventMode: 'stash',
      stash: {
        component: 'n/a',
        pageType: 'giftcard',
        section: 'gift card reload',
        target: 'atc'
      }
    };
    window.digitalData.event.push(eventData);

    const submitData = {
      category: { primaryCategory: 'overlay' },
      eventInfo: { eventName: 'gift card reload' },
      cart: { cartID },
      item: [
        {
          productInfo: { sku: '999999999' },
          price: {
            basePrice: '0.00',
            giftCardPrice: '00.00',
            giftCardReloadPrice: price
          },
          fulfillment: { method: 'sth' }
        }
      ]
    };
    window.digitalData.event.push(submitData);

    const _ddo = window.digitalData.init();
    window._T = window._T || {};

    if (typeof window._T.pageData === 'undefined') {
      window._T.pageData = [];
    }
    window._T.pageData.push(_ddo);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};
